<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Outpatient appointment and service hours</h3>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="2">Category</th>
                            <th colspan="2">Outpatient appointment and service hours</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2">Service application</td>
                            <td rowspan="2">Weekdays</td>
                            <td>Morning</td>
                            <td>08:30 ~ 11:45</td>
                        </tr>
                        <tr>
                            <td>Afternoon</td>
                            <td>12:30 ~ 16:45</td>
                        </tr>
                        <tr>
                            <td rowspan="2">Service hours</td>
                            <td rowspan="2">Weekdays</td>
                            <td>Morning</td>
                            <td>09:00 ~ 12:00</td>
                        </tr>
                        <tr>
                            <td>Afternoon</td>
                            <td>13:00 ~ 17:00</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt10 font-sub">
                ※ No service on Saturdays.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        mounted() {
        },
    }
</script>